// tags 名稱定義：標籤 = 概念股 = 相關產業
/**
 * 相關概念股 api
 * doc. https://www.notion.so/statementdog/Spec-api-spec-c765435c6a834badaa1d384b9ca43f6b
 * @param {String} ticker
 * @return {String}
 */
export const getRelatedTagsAPIUrl = ({ ticker }) => `/api/v1/stocks/${ticker}/related_tags`

/**
 * 個股指標相關產業排名 api
 * doc. https://www.notion.so/statementdog/Spec-46dae0c87cbd474b8dd6e30c0a24a739
 * @param {String} ticker
 * @param {String} indicator
 * @return {String}
 */
export const getTagsIndicatorRankingAPIUrl = ({ ticker, indicator }) => `/api/v1/stocks/${ticker}/indicators/${indicator}/ranking_in_related_tags`

/**
 * 個股指標相關產業 Top 3 api
 * doc. https://www.notion.so/statementdog/Spec-72c92985b9344fc28e608c283a935d98
 * @param {String} ticker
 * @param {String} indicator
 * @return {String}
 */
export const getTagsIndicatorTop3APIUrl = ({ ticker, indicator }) => `/api/v1/stocks/${ticker}/indicators/${indicator}/compare_to_top3_in_related_tags`

/**
 * 個股指標相關產業排行榜 api
 * doc. https://www.notion.so/statementdog/Spec-a58fbb2c61d04806874664664810713e
 * @param {String} ticker
 * @param {String} indicator
 * @return {String}
 */
export const getTagsIndicatorLeaderboardAPIUrl = ({ ticker, indicator }) => `/api/v1/stocks/${ticker}/indicators/${indicator}/related_tags_leaderboards`
